
document.addEventListener("DOMContentLoaded", function() {
  class Carousel {
    constructor(container) {
      this.container = container;
      this.track = container.querySelector('.carousel-track');
      this.dotsContainer = container.querySelector('.carousel-dots');
      this.currentIndex = 0;
      this.autoplayInterval = 5000;
      this.slides = [];
      
      this.init();
    }

    init() {
      this.updateSlides();
      this.initializeClickHandlers();
      this.createDots();
      this.setupEventListeners();
      this.startAutoplay();
    }

    updateSlides() {
      this.slides = Array.from(this.track.querySelectorAll('.slide-wrapper')).filter(
        slide => {
          const img = slide.querySelector('.carousel-slide');
          return window.getComputedStyle(img).display !== 'none';
        }
      );
    }

    initializeClickHandlers() {
      this.slides.forEach(wrapper => {
        const img = wrapper.querySelector('.carousel-slide');
        const link = img.dataset.link;
        const target = img.dataset.target;

        // Only add click handler if there's a link
        if (link && link.trim() !== '') {
          wrapper.style.cursor = 'pointer';
          
          wrapper.addEventListener('click', (e) => {
            // Prevent click if user is dragging/swiping
            if (this.isDragging) return;
            
            if (target === '_blank') {
              window.open(link, '_blank');
            } else {
              window.location.href = link;
            }
          });
        }
      });
    }

    createDots() {
      this.dotsContainer.innerHTML = '';
      this.slides.forEach((_, index) => {
        const dot = document.createElement('div');
        dot.classList.add('carousel-dot');
        if (index === 0) dot.classList.add('active');
        dot.addEventListener('click', () => this.moveToSlide(index));
        this.dotsContainer.appendChild(dot);
      });
    }

    updateSlidePosition() {
      const slideWidth = this.slides[0].getBoundingClientRect().width;
      this.track.style.transform = `translateX(-${this.currentIndex * slideWidth}px)`;

      // Update active dot
      const dots = Array.from(this.dotsContainer.children);
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === this.currentIndex);
      });
    }

    moveToSlide(index) {
      this.currentIndex = index >= this.slides.length ? 0 : index;
      this.updateSlidePosition();
    }

    setupEventListeners() {
      window.addEventListener('resize', () => {
        this.updateSlides();
        this.createDots();
        this.updateSlidePosition();
      });

      // Touch events for mobile swipe
      let startX, moveX;
      this.isDragging = false;
      
      this.container.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        this.isDragging = false;
      });

      this.container.addEventListener('touchmove', (e) => {
        moveX = e.touches[0].clientX;
        this.isDragging = true;
      });

      this.container.addEventListener('touchend', () => {
        const diff = startX - moveX;
        if (Math.abs(diff) > 50) { // minimum swipe distance
          if (diff > 0 && this.currentIndex < this.slides.length - 1) {
            this.moveToSlide(this.currentIndex + 1);
          } else if (diff < 0 && this.currentIndex > 0) {
            this.moveToSlide(this.currentIndex - 1);
          }
        }
        
        // Reset dragging flag after a short delay
        setTimeout(() => {
          this.isDragging = false;
        }, 100);
      });
    }

    startAutoplay() {
      setInterval(() => {
        this.moveToSlide(this.currentIndex + 1);
      }, this.autoplayInterval);
    }
  }

  // Initialize carousel
  const carouselContainer = document.querySelector('.carousel-container');
  if (carouselContainer) {
    new Carousel(carouselContainer);
  }
});